import QueryString from 'query-string';
import config from '~/config';

export default function buildProductGroupUrl(
	groupId: string,
	priceType: string | null = config.product.defaultPriceType,
	productId: string | null = null,
	currency: string = config.product.defaultPriceCurrency,
	showNotificationSettings = false,
	filterCalculatedPrice = false,
	showHistory = false
): { pathname: string; search: string } {
	return {
		pathname: `/product-groups/${encodeURIComponent(groupId)}${
			productId !== null ? `/${encodeURIComponent(productId)}` : ''
		}`,
		search: QueryString.stringify({
			currency: currency !== config.product.defaultPriceCurrency ? currency ?? 'any' : undefined,
			price: priceType !== config.product.defaultPriceType ? priceType ?? 'first-available' : undefined,
			'no-calc-price': filterCalculatedPrice ? 1 : undefined,
			'notification-settings': showNotificationSettings ? '1' : undefined,
			'show-history': showHistory ? '1' : undefined,
		}),
	};
}
